"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gotoKnownUser = exports.DIRECT_CHAT_CREATED = void 0;
const gotoChat_1 = require("./gotoChat");
const chatFunctions = __importStar(require("../../domain/model/chats"));
exports.DIRECT_CHAT_CREATED = "DIRECT_CHAT_CREATED";
function default_1(user) {
    return (dispatch, getState) => {
        gotoUser(dispatch, getState, user);
    };
}
exports.default = default_1;
// Only use this method if the user's details are already stored in the state
function gotoKnownUser(userId) {
    return (dispatch, getState) => {
        const userDictionary = getState().usersState.userDictionary;
        const user = userDictionary[userId];
        if (!user) {
            throw new Error("User details not found in state - " + userId);
        }
        gotoUser(dispatch, getState, user);
    };
}
exports.gotoKnownUser = gotoKnownUser;
function gotoUser(dispatch, getState, user) {
    const chats = getState().chatsState.chats;
    const directChatIndex = chatFunctions.findDirectChatIndex(chats, user.userId);
    // If I already have a direct chat with this user then select it otherwise setup a new direct chat
    if (directChatIndex >= 0) {
        dispatch(gotoChat_1.gotoChatByIndex(directChatIndex));
    }
    else {
        const newChat = chatFunctions.newUnconfirmedDirectChat(user.userId, user.chatId);
        const directChatCreatedEvent = {
            type: exports.DIRECT_CHAT_CREATED,
            payload: {
                chat: newChat,
                user
            }
        };
        dispatch(directChatCreatedEvent);
    }
}
